import { useState } from "react";
import type { SessionSummary } from "../generated/api/types.gen";
import { getDesignTitle, startSessionDrag } from "./gallery/galleryTree";
import { LoadingSpinner } from "./LoadingSpinner";

interface GalleryImageCardProps {
  session: SessionSummary;
  onClick: () => void;
}

export function GalleryImageCard({ session, onClick }: GalleryImageCardProps) {
  const [imageLoaded, setImageLoaded] = useState(false);
  const {
    last_image: image,
    image_count: imageCount,
    max_depth: maxDepth,
  } = session;
  const title = getDesignTitle(session);

  return (
    <button
      type="button"
      draggable
      onDragStart={(event) => startSessionDrag(session, event)}
      className="group relative aspect-square overflow-hidden rounded-[22px] text-left shadow-sm transition-all hover:-translate-y-0.5 hover:shadow-xl"
      onClick={onClick}
    >
      {!imageLoaded && (
        <div className="absolute inset-0 flex items-center justify-center bg-[var(--bg-field)]">
          <LoadingSpinner size="md" />
        </div>
      )}
      <img
        src={image.url ?? undefined}
        alt={title}
        className={`h-full w-full object-cover transition duration-300 group-hover:scale-105 ${
          !imageLoaded ? "opacity-0" : "opacity-100"
        }`}
        onLoad={() => setImageLoaded(true)}
      />

      <div className="absolute inset-x-7 bottom-7 flex flex-col gap-1 rounded-lg bg-white p-2">
        <div className="flex min-w-0 items-baseline gap-3">
          <div className="min-w-0 truncate text-gallery-image-card-title">
            {title}
          </div>
          <div className="shrink-0 text-gallery-image-card-refinement-count">
            ({maxDepth} Refinement{maxDepth !== 1 ? "s" : ""})
          </div>
        </div>
        <div className="text-gallery-image-card-image-count">
          {imageCount} Image{imageCount !== 1 ? "s" : ""}
        </div>
      </div>
    </button>
  );
}
